export const STRATEGY_AND = 'AND';
export const STRATEGY_OR = 'OR';
export const STRATEGY_NOT = 'NOT';

export default {
  STRATEGY_AND,
  STRATEGY_OR,
  STRATEGY_NOT,
};
